export enum SeatType {
  Seat = 'seat',
  Window = 'window',
  Aisle = 'aisle',
}
